module.exports = __webpack_public_path__ + "static/media/cartshoppingRegular.a2a04d97.svg";